import { useAppDispatch, useAppSelector } from 'app/store';
import { uiModel } from 'entities/ui';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useTabsNavigate = (page: string, firstTabKey: string): [string, (key: string) => void] => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { active } = useAppSelector(uiModel.Tabs.selectors.selectTabs);
  // при клике по табу делаю запись в историю, в объекте
  // state присваиваю значение активного таба свойству to(key - имя активного таба)
  // его записываю на память

  const tabsHandler = (key: string) => {
    navigate(``, { state: { from: location.pathname, to: key } });
    dispatch(uiModel.Tabs.actions.setActive(key));
  };

  // присваиваю значение активного таба при инициализации
  useEffect(() => {
    dispatch(uiModel.Tabs.actions.setActive(firstTabKey));
  }, []);

  // запускаю при изменении текущей страницы и местоположения
  useEffect(() => {
    const currentLocationState = location?.state as { from: string; to: string } | null;
    // если есть объект state
    if (currentLocationState) {
      // если мы находимся на текущей странице
      if (currentLocationState.from.includes(page)) {
        // если есть свойство куда
        if (currentLocationState.to) {
          // присваиваем это значение активного таба
          dispatch(uiModel.Tabs.actions.setActive(currentLocationState.to));
        }
      }
      // если нет объекта state и мы не на 1й странице, активируем её
    } else {
      if (active !== firstTabKey) {
        dispatch(uiModel.Tabs.actions.setActive(firstTabKey));
      }
    }
  }, [location, page]);

  // возвращаю:
  //   * key активного таба для динамичсекого открытия вкладок
  //   * функцию-щёлкалку с фукционалом записи перемещения по табам в историю
  return [active, tabsHandler];
};

export default useTabsNavigate;
